import { render, staticRenderFns } from "./debitCardPolicyList.vue?vue&type=template&id=67b6f168&scoped=true&"
import script from "./debitCardPolicyList.vue?vue&type=script&lang=js&"
export * from "./debitCardPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6f168",
  null
  
)

export default component.exports